import * as types from './boardList.types';
import * as constants from './boardList.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../../generators/resource.actions';

export const storeBoardList = generateStoreResourceAction<types.IBoardList>(constants.STORE_BOARD_LIST);
export const clearBoardList = generateClearResourceAction(constants.CLEAR_BOARD_LIST);
